var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIosColor = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C114.62 512 0 397.38 0 256C0 114.62 114.62 0 256 0C397.38 0 512 114.62 512 256C512 397.38 397.38 512 256 512Z",
    id: "de0URQXp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.42 83.5C326.62 103.74 318.51 124 306.52 138.6C294.51 153.17 274.85 164.53 255.56 163.01C252.94 143.22 262.66 122.57 273.81 109.63C286.19 95.07 307.14 84.23 324.42 83.5ZM319.53 428.04C296.49 428.48 289.1 414.35 262.8 414.35C236.48 414.35 228.24 427.6 206.49 428.48C183.88 429.33 166.69 405.77 152.24 384.83C122.71 342.02 100.16 263.79 130.48 210.99C145.49 184.77 172.39 168.18 201.54 167.74C223.74 167.33 244.71 182.76 258.27 182.76C271.85 182.76 297.31 164.24 324.06 166.96C335.27 167.42 366.7 171.48 386.9 201.12C385.3 202.17 349.37 223.14 349.81 266.83C350.24 319.01 395.39 336.35 395.92 336.59C395.5 337.82 388.69 361.35 372.12 385.67C357.77 406.7 342.94 427.6 319.53 428.04Z",
    id: "e4NkcC5Ho"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#de0URQXp",
    opacity: 1,
    fill: "#4086CD",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#de0URQXp",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e4NkcC5Ho",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e4NkcC5Ho",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIosColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ios_color.8f5d21b6d1c5aa265c83d62ddb3c0d9e.svg";